export default __webpack_public_path__ + "static/media/712d054956ced01c.000811afe2a46113fbff3ef416ab078f.svg";